// src/components/Admin/TrialNotification.js
import React, { useState, useEffect } from 'react';
//import { doc, updateDoc } from 'firebase/firestore';
//import { db } from '../../services/firebase.js';

const TrialNotification = ({ company }) => {
    const [showNotification, setShowNotification] = useState(false);
    const [daysLeft, setDaysLeft] = useState(0);

    useEffect(() => {
        if (!company?.plan) return;

        const trialEnd = company.plan.trialEndDate.toDate();
        const now = new Date();
        const timeLeft = trialEnd - now;
        const daysRemaining = Math.ceil(timeLeft / (1000 * 60 * 60 * 24));

        // Show notification if between 30 and 0 days left of trial
        if (daysRemaining <= 30 && daysRemaining > 0 && company.plan.type === 'Free') {
            setShowNotification(true);
            setDaysLeft(daysRemaining);
        }
    }, [company]);

    const handleStartSubscription = () => {
        // TODO: Implement payment flow
        window.location.href = '/admin/subscription';
    };

    if (!showNotification) return null;

    return (
        <div className="fixed bottom-4 right-4 max-w-md bg-white rounded-lg shadow-lg p-6 border-2 border-amber-500">
            <div className="flex items-start">
                <div className="flex-shrink-0">
                    <svg className="h-6 w-6 text-amber-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                </div>
                <div className="ml-3">
                    <h3 className="text-lg font-semibold text-gray-900">
                        {daysLeft} dage tilbage af prøveperioden
                    </h3>
                    <p className="mt-2 text-sm text-gray-600">
                        For at beholde din hjemmeside aktiv efter prøveperioden, skal du opgradere til et betalende abonnement.
                    </p>
                    <div className="mt-4">
                        <button
                            onClick={handleStartSubscription}
                            className="inline-flex items-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-amber-600 hover:bg-amber-700"
                        >
                            Opgrader nu - 249 kr/md
                        </button>
                        <button
                            onClick={() => setShowNotification(false)}
                            className="ml-3 text-sm text-gray-600 hover:text-gray-800"
                        >
                            Påmind mig senere
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TrialNotification;